import React, {useEffect, useState} from 'react';
import {apiGet} from "../../services/apiClient";
import Dropdown from "../Dropdown";

const Select = ({
                    value,
                    onChange,
                    sourceOptionsUrl,
                    disabled,
                    error
                }) => {
    const [options, setOptions] = useState([]);
    const getOptions = () => {
        apiGet(sourceOptionsUrl)
            .then(d => {
                setOptions((d.entries || []).map(o => ({
                    text: o.name,
                    value: o.id,
                    key: o.id
                })) || [])
            })
            .catch(e => console.error(e))
    }

    useEffect(() => {
        getOptions()
    }, [sourceOptionsUrl]);

    return (
        <Dropdown
            error={error}
            onChange={onChange}
            disabled={disabled}
            value={value}
            options={options}
        />
    );
};

export default Select;


// WEBPACK FOOTER //
// ./App/components/Field/Select.jsx